import styled, { css, keyframes } from 'styled-components';
import theme from '../../styles/material';
import background from '../../assets/images/chat2.jpeg';
import { IconButton } from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';
import colors from '../../styles/colors';
import { FaImage, FaVideo } from 'react-icons/fa';

export const Input = styled(InputBase)`
  width: 100%;
  border: none;
  padding-left: 20px;
  padding-right: 20px;
`;
export const InputContainer = styled.div`
  width: 100%;
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #f0f0f0;
  background-color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  Input {
    border: none;
    background-color: transparent;
    flex: 1;
  }
  img {
    height: 24px;
    width: 24px;
  }
`;

export const Container = styled.div`
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  right: 0;
  bottom: 0;
  top: 60px;
  left: 350px;
  padding: 30px;
  padding-top: 0px;
  background-color: #f0f0f0;
`;
export const Content = styled.div`
  overflow-y: auto;
  padding: 30px;
  padding-top: 0px;
  padding-bottom: ${(props) => props.height + 'px'};
  background-color: #f0f0f0;
  /* background: url(${background}); */
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  flex: 1;
  /* ${(props) =>
    props.isMessageSelected === true &&
    css`
      padding-bottom: 130px;
    `};
  ${(props) =>
    props.isEmojisOpened === true &&
    css`
      padding-bottom: 390px;
    `};
    */
`;

export const SendContent = styled.form`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background-color: #e0e0e0;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  width: 100%;
  svg {
    color: ${theme.palette.secondary.main};
    font-size: 26px;
    cursor: pointer;
  }
  button {
    border: none;
    background-color: transparent;
  }
  label {
    input {
      display: none;
    }
  }
`;

export const BottomContent = styled.div`
  position: absolute;
  overflow-y: auto;
  right: 0;
  bottom: 0;
  left: 350px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background-color: #e0e0e0;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 20px;
`;
export const ButtonClose = styled(IconButton)``;
export const ButtonScrollDown = styled.div`
  position: absolute;
  bottom: 60px;
  right: 10px;
  background-color: ${colors.primary} !important;
  color: #fff !important;
  height: 36px;
  width: 36px;
  border-radius: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Unread = styled.div`
  padding: 8px;
  background: #e0e0e0;
  border-radius: 10px;
  color: #999;
  text-align: center;
`;
export const RepliedMessage = styled.div`
  padding: 10px;
  background-color: #e0e0e0;
  border-left: 2px solid #666;
  border-radius: 10px;
  text-align: left;
  min-height: 30px;
  margin: 10px 0px;

  ul,
  ol {
    padding-left: 20px;
    margin: 4px 0;
  }

  li {
    margin-bottom: 2px;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }
`;
export const MessageContent = styled.div`
  background-color: #e0e0e0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 5px;
  padding-bottom: 50px;
  z-index: 100;
  margin-left: 90px;
`;

export const ForwardText = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  top: 2px;
  left: 2px;
  font-size: 12px;
  color: #999;
  flex-direction: column;
  justify-content: flex-start;
  text-align: start;
  margin-bottom: 5px;
`;

export const MessageMarked = styled.div`
  background: #f0f0f0;
  position: relative;
  padding-top: 25px;
  padding-right: 25px;
  padding-left: 10px;
  padding-bottom: 10px;
  overflow: hidden;
  font-size: 14px;
  border-radius: 10px;
  ${ButtonClose} {
    position: absolute;
    top: -10px;
    right: -10px;
  }
`;
export const BalloonDate = styled.div`
  position: absolute;
  right: 20px;
  bottom: 6px;
  padding: 2px;
  font-size: 11px;
`;
export const BalloonActions = styled.div`
  position: absolute;
  top: 0px;
  right: 5px;
  color: #999;
  transition: visibility 0.1ms;
`;

export const BalloonInfo = styled.div`
  position: absolute;
  right: 4px;
  bottom: 0px;
  svg {
    width: 15px;
  }
  .accent-icon {
    color: ${colors.primary};
  }
`;

export const AttachmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  margin: 5px 0px;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 510px; /* Limits the bubble width to hold 3 items maximum (3 * 150px = 450px + gaps) */
`;

export const Emoji = styled.span`
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 0px;
  margin: 0px 4px;
  border-radius: 4px;
  transition: transform 0.1s;

  &:hover {
    transform: scale(1.25);
  }

  ${({ $reacted }) =>
    $reacted &&
    css`
      border-radius: 0px;
      border-bottom: 2px solid ${colors.brand_500};
    `}
`;

const trayFadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`;
export const EmojiTray = styled.div`
  position: absolute;
  top: -35px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
  z-index: 10;
  animation: ${trayFadeIn} 0.15s ease-out;

  span {
    cursor: pointer;
  }

  ${({ $isSender }) => ($isSender ? 'right: 0;' : 'left: 0;')}

  /* invisible bridge so the tray doesn't vanish when moving the mouse to it */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -10px;
    height: 10px;
  }
`;

export const Balloon = styled.div`
  min-width: 130px;
  max-width: 550px;
  margin: 10px;
  border-radius: 5px;
  padding: 20px 10px;
  text-align: left;
  font-weight: 500;
  font-family: arial;
  position: relative;

  padding-bottom: 30px;
  margin-bottom: 20px;

  ${BalloonActions} {
    visibility: hidden;
  }
  ${(props) =>
    props.isDeleted &&
    css`
      padding-bottom: 15px;
    `}

  ${(props) =>
    props.isToday &&
    css`
      min-width: 55px;
    `}

    ${(props) =>
    props.isForward &&
    props.isToday &&
    css`
      min-width: 100px !important;
      background-color: red;
      padding-top: 5px;
      padding-left: 10px;
    `}

      ${(props) =>
    props.isForward &&
    css`
      min-width: 100px !important;
      background-color: red;
      padding-top: 5px;
      padding-left: 10px;
    `}

  ${(props) =>
    props.my === false &&
    css`
      text-align: left;
      align-self: flex-start;
      box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, 0.2);
      background-color: #fff;
      color: #000 !important;
      &:before {
        content: '';
        width: 0px;
        height: 0px;
        position: absolute;
        border-left: 10px solid transparent;
        border-right: 10px solid #fff;
        border-top: 10px solid #fff;
        border-bottom: 10px solid transparent;
        left: -10px;
        top: 6px;
      }
    `}

  ${(props) =>
    props.my === true &&
    css`
      text-align: right;
      align-self: flex-end;
      box-shadow: -2px 2px 3px 1px rgba(0, 0, 0, 0.2);
      background-color: #f9fbe7;
      color: #333;
      &:before {
        content: '';
        width: 0px;
        height: 0px;
        position: absolute;
        border-left: 10px solid #f9fbe7;
        border-right: 10px solid transparent;
        border-top: 10px solid #f9fbe7;
        border-bottom: 10px solid transparent;
        right: -10px;
        top: 6px;
      }
    `}
    &:hover {
    ${BalloonActions} {
      visibility: visible;
    }
  }

  /* ===== Reaction List & Items ===== */
  .reaction-list {
    position: relative;
    bottom: -46px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 1px;
    width: max-content;
    white-space: nowrap;
    padding: 0;
    background: none;
    overflow: visible;
    z-index: 2;
    height: 0;
    font-size: 14px;

    &.count-right {
      right: 0;
      left: auto;
    }

    &.count-left {
      left: 0;
      right: auto;
    }
  }

  .reaction-item {
    position: relative;
    display: inline-flex;
    align-items: center;
    margin-top: -15px;
    margin-right: 6px;
    padding: 3px 8px;
    border-radius: 24px;
    cursor: pointer;
    border: 1px solid #ccc;
    background: #ffffff;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      height: 6px;
    }

    &:hover .hover-users {
      display: block;
    }

    &.more .hover-users {
      pointer-events: none;
    }

    &.more:hover .hover-users {
      pointer-events: auto;
    }
  }

  .hover-users {
    background: white;
    border-radius: 8px;
    min-width: 150px;
    max-width: 250px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    position: absolute;
    z-index: 999999;
    display: none;
    white-space: nowrap;

    &.hover-up {
      bottom: 100%;
      margin-bottom: 2px;
    }

    &.hover-down {
      top: 100%;
      margin-top: 4px;
    }

    &.count-right {
      right: 0;
      left: auto;
      top: auto;
      bottom: 100%;
      margin-bottom: 4px;
    }

    &.count-left {
      left: 0;
      right: auto;
      top: auto;
      bottom: 100%;
      margin-bottom: 4px;
    }
  }

  .reaction-user {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    font-size: 13px;
    color: black;
  }

  .remove-btn {
    margin-left: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  &:has(.reaction-list:hover) .emoji-tray-target {
    display: none !important;
  }
`;

export const MessageLink = styled.a`
  color: ${colors.primary};
`;

export const MessageText = styled.div`
  text-align: left;
  max-width: 510px;
  word-wrap: break-word;
  strong {
    font-weight: 600;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
  }

  ul,
  ol {
    padding-left: 36px;
    margin: 8px 0;
  }

  li {
    margin-bottom: 4px;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;
  background-color: #f1f2f6;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;
  border: 1px solid #ffcdd2;
  background-color: #ffebee;
  color: #c62828;
  font-size: 11px;
  padding: 8px;
  text-align: center;
  box-sizing: border-box;
`;

export const DecryptedImage = styled.img`
  width: 150px;
  height: 150px;
  object-fit: cover;
  cursor: pointer;
`;

export const DecryptedVideo = styled.video`
  width: 150px;
  height: 150px;
  object-fit: cover;
`;

export const LargeMediaCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  background-color: #f9f9f9;
  padding: 8px;
  box-sizing: border-box;
`;

export const LargeMediaIconContainer = styled.div`
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  svg {
    width: 32px;
    height: 32px;
  }
`;

export const LargeMediaTitle = styled.span`
  font-size: 11px;
  font-weight: bold;
  color: #555;
  margin-bottom: 4px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
`;

export const LargeMediaSubtitle = styled.span`
  font-size: 9px;
  color: #888;
  margin-bottom: 8px;
`;

export const StyledVideoIcon = styled(FaVideo)`
  color: #333;
`;
export const StyledImageIcon = styled(FaImage)`
  color: ${colors.primary};
`;
export const LargeMediaButton = styled.button`
  padding: 4px 8px !important;
  background-color: ${colors.primary} !important; /* Dynamic primary theme color */
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
  font-weight: bold;
  width: auto !important;
  height: auto !important;
`;

export const DownloadButton = styled.button`
  position: absolute !important;
  top: 5px !important;
  right: 5px !important;
  z-index: 10 !important;
  border: 1px solid #ccc !important;
  border-radius: 50% !important;
  width: 26px !important;
  height: 26px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  cursor: pointer !important;
  color: #333 !important;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);

  /* Always visible */
  opacity: 1 !important;
  visibility: visible !important;
  transform: scale(1) !important;

  transition: all 0.15s ease;
  background-color: #e2e8f0 !important;

  &:hover {
    background-color: #ffffff !important;
    color: ${colors.primary} !important;
  }
`;

export const AttachmentFile = styled.div`
  display: flex;
  width: 150px;
  height: 150px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: #f1f2f6;
  border: 1px solid #dee2e6;
  padding: 0;
  margin: 5px;
  /* Image styling */
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }

  /* Video player styling */
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  /* File icons & links (links/buttons) */
  a,
  button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
    padding: 10px;
    cursor: pointer;
    box-sizing: border-box;
    outline: none;

    /* Centered ellipsis filename */
    p {
      margin: 0;
      font-family: arial;
      font-weight: 500;
      color: #333;
      font-size: 11px;
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const EditedLabel = styled.span`
  position: absolute;
  top: -14px;
  ${(props) => (props.my ? 'right: 4px;' : 'left: 4px;')}
  font-size: 11px;
  color: #707579;
  font-weight: 400;
  white-space: nowrap;
`;

export const FloatingEmojiPicker = styled.div`
  position: absolute;
  z-index: 9999;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  border: 1px solid #e5e7eb;
  overflow: hidden;

  /* reset what it inherits from Balloon */
  white-space: normal;
  text-align: left;
  font-weight: 400;
  line-height: normal;
  cursor: default;

  ${({ $isSender }) => ($isSender ? 'right: 0;' : 'left: 30px;')}

  ${({ $showAbove }) =>
    $showAbove
      ? css`
          bottom: calc(100% + 8px); /* above the hover tray */
        `
      : css`
          top: 20px;
        `}
`;
